import _styled from '@emotion/styled/base';
import TertiaryButton from '../Button/TertiaryButton.js';
import { Spacing } from '../primitives/spacing.js';
import { mediaQuery } from '../primitives/media-queries.js';

const NavMenuContainer = _styled('div', {
  target: "e1ah4ggt1"
})("padding:", Spacing.scale[3], " ", Spacing.scale[1.5], " 0 ", Spacing.scale[4], ";@media (", mediaQuery.tabletSmDown, "){padding:0;}");
const NavButton = _styled(TertiaryButton, {
  target: "e1ah4ggt0"
})("justify-content:flex-start;color:", props => props.active && props.theme.colorScheme.action.content.tertiary.neutral.active, ";background:", props => props.active && props.theme.colorScheme.action.background.tertiary.neutral.active, ";text-align:left;");

export { NavButton, NavMenuContainer };
